var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75065 12.832C3.25691 12.832 3.66732 13.2424 3.66732 13.7487V17.4154C3.66732 17.6585 3.76389 17.8916 3.9358 18.0635C4.10771 18.2355 4.34087 18.332 4.58398 18.332H17.4173C17.6604 18.332 17.8936 18.2355 18.0655 18.0635C18.2374 17.8916 18.334 17.6585 18.334 17.4154V13.7487C18.334 13.2424 18.7444 12.832 19.2507 12.832C19.7569 12.832 20.1673 13.2424 20.1673 13.7487V17.4154C20.1673 18.1447 19.8776 18.8442 19.3619 19.3599C18.8461 19.8756 18.1467 20.1654 17.4173 20.1654H4.58398C3.85464 20.1654 3.15517 19.8756 2.63944 19.3599C2.12372 18.8442 1.83398 18.1447 1.83398 17.4154V13.7487C1.83398 13.2424 2.24439 12.832 2.75065 12.832Z",
    fill: "#017C57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76849 8.51849C6.12647 8.1605 6.70687 8.1605 7.06485 8.51849L11 12.4536L14.9352 8.51849C15.2931 8.1605 15.8735 8.1605 16.2315 8.51849C16.5895 8.87647 16.5895 9.45687 16.2315 9.81485L11.6482 14.3982C11.2902 14.7562 10.7098 14.7562 10.3518 14.3982L5.76849 9.81485C5.4105 9.45687 5.4105 8.87647 5.76849 8.51849Z",
    fill: "#017C57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0007 1.83203C11.5069 1.83203 11.9173 2.24244 11.9173 2.7487V13.7487C11.9173 14.255 11.5069 14.6654 11.0007 14.6654C10.4944 14.6654 10.084 14.255 10.084 13.7487V2.7487C10.084 2.24244 10.4944 1.83203 11.0007 1.83203Z",
    fill: "#017C57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconGreen);
export default __webpack_public_path__ + "static/media/downloadIconGreen.0b45945be994ec2830667d83f40e39f1.svg";
export { ForwardRef as ReactComponent };